import { GET_USER_PRORATION_PRICE_FAILURE, POST_CHECKOUT_SUBSCRIPTION_UPGRADE_FAILURE } from 'redux/actions';
import { arrayContains } from 'utils';

export const isUpgradeSubscriptionFailed = (state) =>
  arrayContains(state.payment.failedRequests, [GET_USER_PRORATION_PRICE_FAILURE, GET_USER_PRORATION_PRICE_FAILURE]);
